import styled from 'styled-components';
import ShopCard from '../ShopCard/ShopCard';
import LayoutCollectionView from '../LayoutCollectionView/LayoutCollectionView';
import { GRID, SHOPS } from '../../../../lib/constants';
import { saveShop, removeShopById } from '../../../../lib/user';

const ShopGroupDiv = styled.div`
  padding: ${p => p.isMobile ? p.theme.unit(4) : p.theme.unit(8)} 0;
  border-bottom: ${p => (p.isLastChild ? 'none' : (`1px solid ${p.theme.c.border.primary}`))};
`;

const LetterHeading = styled.h2`
  ${({ theme }) => theme.typographyRebrand.heading['2xl']}
  text-align: left;
  color: ${p => p.theme.c.text.primary};
  margin-bottom: ${p => p.theme.unit(2)};
`;

const ShopGroup = (props) => {
  const {
    letter,
    shops,
    locale,
    index,
    length,
    pageStateModifiers,
    userData,
    isMobile,
  } = props;

  const isLastChild = (index === length - 1);
  const favShops = userData && userData.shops ? userData.shops : [];
  const favShopIds = favShops.map(shop => shop.id);

  return (
    <ShopGroupDiv id={letter} isLastChild={isLastChild} isMobile={isMobile}>
      <LetterHeading isMobile={isMobile}>
        {letter}
      </LetterHeading>
      <LayoutCollectionView
        styleDesktop={{justifyContent: 'flex-start'}}
        styleMobile={{justifyContent: 'flex-start'}}
        favItemIds={favShopIds}
        items={shops}
        Comp={ShopCard}
        itemType={SHOPS}
        viewType={GRID}
        saveItemHandler={saveShop}
        removeItemHandler={removeShopById}
        pageStateModifiers={pageStateModifiers}
        locale={locale}
        pageContext={`shop-group-${letter}`} />
    </ShopGroupDiv>
  );
};

export default ShopGroup;
